import { ReactElement } from "react";
import { IUserInfo } from "../../messages/IAppInfo";
import { redirectTo } from "../../utils/redirect";

export default function Eula(props: {
  userInfo: IUserInfo,
  path: string,
}): ReactElement {
  // If we ended up here, then eula_accepted is false, but we want to check it again just in case
  if (!props.userInfo?.eula_accepted && !props.userInfo?.impersonated) {
      //window.location.href = `/eula?next=%2F${props.url}`;
      redirectTo(`/eula?next=${encodeURIComponent(props.path)}`);
  }
  // TODO: Implement in React
  return <>
  </>
}
